import { render, staticRenderFns } from "./ManageFaq.vue?vue&type=template&id=2678d8ca&"
import script from "./ManageFaq.vue?vue&type=script&lang=js&"
export * from "./ManageFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports